import { Field } from 'formik'
import { clamp, isEmpty } from 'lodash'
import React from 'react'
import { QuantityCounter, type QuantityCounterProps } from 'components/Counter'

interface ProductQuantityCounterFieldProps
  extends Pick<
    QuantityCounterProps,
    'id' | 'minimumOrderQuantity' | 'quantityUnit' | 'isDisabled' | 'textProps'
  > {
  name: string
  availableQuantity: number
}

export const ProductQuantityCounterField: React.FC<
  React.PWC<ProductQuantityCounterFieldProps>
> = ({ id, name, minimumOrderQuantity, availableQuantity, ...rest }) => (
  <Field name={name}>
    {({ field, meta, form: { setFieldValue } }) => {
      // Coerce defensively: if the form's initial values are missing this
      // field (race between cart updates and Formik's mount-time snapshot),
      // `field.value` is undefined and `undefined +/- 1` is NaN.
      const numericValue = Number(field.value)
      const safeValue = Number.isFinite(numericValue)
        ? numericValue
        : minimumOrderQuantity
      return (
        <QuantityCounter
          {...field}
          id={id}
          onChange={({ target: { value } }) => {
            const inputQuantity = parseInt(value) || 0
            setFieldValue(
              field.name,
              clamp(inputQuantity, 0, availableQuantity)
            )
          }}
          onIncrement={() => {
            setFieldValue(field.name, safeValue + 1)
          }}
          onDecrement={() => {
            setFieldValue(field.name, safeValue - 1)
          }}
          isIncrementDisabled={safeValue >= availableQuantity}
          isDecrementDisabled={safeValue <= minimumOrderQuantity}
          minimumOrderQuantity={minimumOrderQuantity}
          isError={meta.touched && !isEmpty(meta.error)}
          {...rest}
        />
      )
    }}
  </Field>
)
